import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { artifactIconVisual } from "@/components/artifacts/artifactKindVisual";

export interface ArtifactKindIconProps {
  kind: string;
  mimeType?: string | null;
  filename?: string | null;
  /** ``card`` — Mission Control / ArtifactCard (round). ``row`` — Artifacts app list. */
  variant?: "card" | "row";
  className?: string;
}

/** File-type or kind icon; renders nothing when neither is mapped. */
export function ArtifactKindIcon({
  kind,
  mimeType,
  filename,
  variant = "card",
  className,
}: ArtifactKindIconProps) {
  const visual = artifactIconVisual(kind, mimeType, filename);
  if (!visual) return null;

  const isRow = variant === "row";

  return (
    <span
      className={clsx(
        "flex shrink-0 items-center justify-center",
        isRow ? "h-9 w-9 rounded-lg" : "h-7 w-7 rounded-full",
        visual.tone.bg,
        visual.tone.text,
        className,
      )}
      aria-hidden
    >
      <FontAwesomeIcon icon={visual.icon} className={isRow ? undefined : "text-sm"} />
    </span>
  );
}
